import Component from 'vue-class-component';
import PageBase from '@/pages/page-base';

@Component({})
export default class DestinationApp extends PageBase {
    constructor(options: any) {
        super(options);
    }

    public run(): void {
    }
}
